import { Button } from '@cocoonspace/ui/components/button'
import { useLingui } from '@lingui/react/macro'

import { useAuth } from '~/providers/auth-provider'

export const GuestFooter = () => {
	const { t } = useLingui()
	const { openRegister } = useAuth()

	return (
		<div className='flex items-center gap-y-2 border-t p-4'>
			<div className='text-sm'>{t`Connectez-vous pour voir les prix et réserver !`}</div>

			<Button
				onClick={() => openRegister()}
				size='sm'
			>
				{t`Se connecter`}
			</Button>
		</div>
	)
}
